'use strict';

var React = require('react');

var SvgHashtagMinor = function SvgHashtagMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.164 3.014a1 1 0 0 1 .822 1.15l-.306 1.836h1.32a1 1 0 1 1 0 2h-1.653l-.666 4h2.319a1 1 0 1 1 0 2h-2.653l-.36 2.164a1 1 0 1 1-1.973-.328l.306-1.836h-3.973l-.36 2.164a1 1 0 1 1-1.973-.328l.306-1.836h-1.32a1 1 0 1 1 0-2h1.653l.667-4h-2.32a1 1 0 1 1 0-2h2.653l.36-2.164a1 1 0 1 1 1.973.328l-.306 1.836h3.973l.36-2.164a1 1 0 0 1 1.151-.822Zm-5.817 4.986-.667 4h3.973l.666-4h-3.972Z"
  }));
};

exports.SvgHashtagMinor = SvgHashtagMinor;
